import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { styles } from '../panel-feature-promotion-banner.styles';
import type { PanelFeaturePromotionBannerMediaProps } from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerMedia: FC<PanelFeaturePromotionBannerMediaProps> = ({
  children,
  noBackground = false,
  className,
  testId,
}) => {
  return (
    <div className={cx(styles.media, noBackground && styles.mediaNoBackground, className)} data-testid={testId}>
      {children}
    </div>
  );
};
